module.exports = __webpack_public_path__ + "img/9a48d53a3d1b58e91ec374be44f987c6.png";